/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { IdentityOption } from 'cio/utils/action-composer';

interface SenderIdentityMenuItemSignature {
  Element: HTMLDivElement;
  Args: {
    item: IdentityOption;
  };
}

export default class SenderIdentityMenuItem extends Component<SenderIdentityMenuItemSignature> {}
